// ┌─────────────────────────────────────────────────────────────────┐
// │  КОНТАКТЫ И ССЫЛКИ САЙТА — редактируй значения здесь, в одном месте │
// └─────────────────────────────────────────────────────────────────┘
// Пустое значение ("") — строка или иконка просто не показывается, сайт не
// ломается. Так и выключаются каналы, которых у компании нет: не удаляем
// ключ, а оставляем его пустым — видно, что канал выключен намеренно.
export const CONTACTS = {
  whatsapp: "https://wa.me/77472635423", // основной канал: сюда ведут все кнопки заявки
  instagram: "https://www.instagram.com/kazakh_japan_tourism/",
  telegram: "", // не используем — иконка скрыта
  youtube: "", // напр. https://youtube.com/@your_channel — пусто = скрыто
  phone: "+77472635423",
  email: "", // не используем — строка с почтой скрыта
};
